import { createApiActionTypes } from 'store';

export const GET_PARTNER_LIST = createApiActionTypes('GET_PARTNER_LIST');
export const UPDATE_PARTNER_LIST = createApiActionTypes('UPDATE_PARTNER_LIST');

export const POST_NEW_PARTNER = createApiActionTypes('POST_NEW_PARTNER');
export const DELETE_PARTNER = createApiActionTypes('DELETE_PARTNER');

export const RESET_ERROR = 'RESET_ERROR';
export const RESET_IS_PARTNER_DELETED = 'RESET_IS_PARTNER_DELETED';

export const GET_PARTNER_DATA = createApiActionTypes('GET_PARTNER_DATA');
export const UPDATE_PARTNER_DATA = createApiActionTypes('UPDATE_PARTNER_DATA');
export const GET_PARTNER_CLIENTS = createApiActionTypes('GET_PARTNER_CLIENTS');
export const GET_PARTNER_ADMINS = createApiActionTypes('GET_PARTNER_ADMINS');
export const GET_PARTNER_DETAILS = createApiActionTypes('GET_PARTNER_DETAILS');

export const RESET_PARTNER_LIST = 'RESET_PARTNER_LIST';
export const RESET_NEW_PARTNER = 'RESET_NEW_PARTNER';
export const RESET_PARTNER_DETAILS = 'RESET_PARTNER_DETAILS';
export const RESET_PARTNER_DATA = 'RESET_PARTNER_DATA';
export const RESET_UPDATE_PARTNER_DATA = 'RESET_UPDATE_PARTNER_DATA';

export const POST_NEW_USER = createApiActionTypes('POST_NEW_USER_DATA');
export const RESET_USER_FORM_DATA = 'RESET_USER_FORM_DATA';
